import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import fetch from 'features/common/fetch';
import { getNotAssignedManagers } from 'features/views/settings/marketPlaceAgencies/selectors';

import Manager from './Manager';

export const NotAssignedManagers = () => {
	const notAssignedManagers = useSelector(getNotAssignedManagers);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<ComponentLoader fetchStorePath={fetch.constants.urls.settingsMarketPlaceAgencies}>
				<Stack spacing={1}>
					<SectionHeader text={getMessage('settings:marketPlaceAgencies.notPlacedManagers')} />
					<Grid container>
						{!isNilOrEmpty(notAssignedManagers) ? (
							notAssignedManagers.map((manager) => (
								<Grid size={12}>
									<Manager manager={manager} />
								</Grid>
							))
						) : (
							<Grid size={12}>
								<Typography>
									{getMessage('settings:marketPlaceAgencies.emptyNotPlacedManagers')}
								</Typography>
							</Grid>
						)}
					</Grid>
				</Stack>
			</ComponentLoader>
		</Paper>
	);
};

export default NotAssignedManagers;
